<template>

	<div class="app-company-switcher">
		<ao-select
			:modelValue="selectedCompanyId"
			:items="availableCompanies"
			item-title="name"
			item-value="id"
			hide-details
			isSearch
			variant="underlined"
			@update:modelValue="onUpdateCurrentCompany"
		/>
	</div>

</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/userStore'

const props = defineProps({
	setToStore: {
		type: Boolean,
		default: true,
	},
})

const emit = defineEmits({
	'update:modelValue': null,
})

const userStore = useUserStore()
const {
	selectedCompanyId,
	availableCompanies,
} = storeToRefs(userStore)
const {
	setSelectedCompanyId,
} = userStore

const onUpdateCurrentCompany = (value) => {
	if (props.setToStore) {
		setSelectedCompanyId(value)
	}

	emit('update:modelValue', value)
}
</script>

<style lang="scss">

</style>
